/**
 * @generated SignedSource<<33c3eeaf8628badd0086ba6bc5a6ec5d>>
 * @relayHash 8e2d8aa99e0938ab9ad468f874e06dbe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 004fc2751164933e3d8189b836f15a34a4cb06d2e904530dc6f6a65702b6d073

import type { ConcreteRequest } from 'relay-runtime';
export type WorkspaceThemePreferenceMutation$variables = {
  accountId: string;
  theme: string;
  workspaceAri: string;
};
export type WorkspaceThemePreferenceMutation$data = {
  readonly settings_updateUserPreferencesWorkspace: {
    readonly theme: string | null;
  } | null;
};
export type WorkspaceThemePreferenceMutation = {
  response: WorkspaceThemePreferenceMutation$data;
  variables: WorkspaceThemePreferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "accountId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "theme"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "theme",
        "variableName": "theme"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_updateUserPreferencesWorkspace",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "WorkspaceThemePreferenceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "WorkspaceThemePreferenceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "8e2d8aa99e0938ab9ad468f874e06dbe",
    "id": "004fc2751164933e3d8189b836f15a34a4cb06d2e904530dc6f6a65702b6d073",
    "metadata": {},
    "name": "WorkspaceThemePreferenceMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceThemePreferenceMutation($workspaceAri:ID!,$accountId:ID!,$theme:String!){settings_updateUserPreferencesWorkspace(workspaceAri:$workspaceAri,accountId:$accountId,theme:$theme){theme}}"
  }
};
})();

(node as any).hash = "86a581fd1bb437709ce4903b5b6d534b";

export default node;
